import { PAGINATION_LIMIT, RESOURCE } from '@src/constants';
import { PACKAGE_STATUS, PACKAGE_TYPE } from '@src/constants/package';
import { ERROR_CODE } from '@src/errors/code';
import { omitIsNil } from '@src/utils/omit';
import api from './api';

const createOrder = async ({
  credits,
  packageId,
  isAutoRenewing = false,
  paymentMethodId,
  paymentInstrument,
  bankCode,
  callbackUrl,
  downgradePackage,
  confirmCancelSubscription,
  phoneNumber,
  voucherId,
  invoice,
  isGlobal,
  affiliateMarketerId,
  dialCode,
  custom,
  creditsPerCycle,
  redeemCode,
}) => {
  // TODO: check response data
  try {
    const response = await api({
      method: 'POST',
      url: RESOURCE.ORDERS,
      data: {
        credits,
        packageId,
        isAutoRenewing,
        paymentMethodId,
        paymentInstrument,
        bankCode,
        callbackUrl,
        downgradePackage,
        confirmCancelSubscription,
        phoneNumber,
        voucherId,
        invoice,
        isGlobal,
        affiliateMarketerId,
        dialCode,
        custom,
        creditsPerCycle,
        redeemCode,
      },
      timeout: 30 * 1000,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const remainingValueOfTheCurrentPackage = async ({
  packageType,
  device = 0,
  maxCloningVoices = 0,
}) => {
  const response = await api({
    method: 'GET',
    url: `/current-plan/remaining-value?packageType=${packageType}&device=${device}&maxCloningVoices=${maxCloningVoices}`,
  });
  return response;
};

const createTrialDubbingOrder = async () => {
  const response = await api({
    method: 'POST',
    url: `${RESOURCE.ORDERS}/dubbing-for-old-user`,
  });
  return response;
};

const getOrderState = async (token) => {
  const response = await api({
    method: 'GET',
    url: `${RESOURCE.ORDERS}/state`,
    params: { token },
  });
  return response;
};

const getOrderById = async (orderId) => {
  const response = await api({
    method: 'GET',
    url: `${RESOURCE.ORDERS}/${orderId}`,
  });
  return response;
};

const getOrders = async (params) => {
  const paramsToGetOrders = {
    ...params,
    limit: params.limit ?? PAGINATION_LIMIT,
  };
  const response = await api({
    method: 'GET',
    url: RESOURCE.ORDERS,
    params: paramsToGetOrders,
  });
  return response;
};

const cancelOrder = async (orderId, note, cancelReason) => {
  const response = await api({
    method: 'POST',
    url: `${RESOURCE.ORDERS}/${orderId}/cancel`,
    data: { note, cancelReason },
  });
  return response;
};

const confirmByCustomer = async (orderId) => {
  const response = await api({
    method: 'POST',
    url: `${RESOURCE.ORDERS}/${orderId}/confirm`,
  });
  return response;
};

const countPaidOrders = async () => {
  const response = await api({
    method: 'GET',
    url: `${RESOURCE.ORDERS}/count-paid-orders`,
  });
  return response;
};

const getLastExpiredOrder = async () => {
  const response = await api({
    method: 'GET',
    url: `${RESOURCE.ORDERS}/last-expired`,
    params: { type: PACKAGE_TYPE.STUDIO },
  });
  return response;
};

const updateMoeStatus = async (orderId) => {
  const response = await api({
    method: 'PUT',
    url: `${RESOURCE.ORDERS}/${orderId}/moe`,
  });
  return response;
};

const getUserPaidOrders = async (usagePackage) => {
  try {
    const response = await api({
      method: 'GET',
      url: `${RESOURCE.ORDERS}`,
      params: {
        type: PACKAGE_TYPE.STUDIO,
        usagePackage,
        status: PACKAGE_STATUS.PAID,
      },
    });
    return response;
  } catch (error) {
    return { status: 0, errorCode: ERROR_CODE.BAD_REQUEST };
  }
};

const getUsingOrders = async () => {
  try {
    const response = await api({
      method: 'GET',
      url: `${RESOURCE.ORDERS}/latest-paid`,
    });
    return response;
  } catch (error) {
    return { status: 0, errorCode: ERROR_CODE.BAD_REQUEST };
  }
};

const getPreviewRolloverCredits = async (packageCode, voucherCode) => {
  try {
    const response = await api({
      method: 'GET',
      url: `${RESOURCE.ORDERS}/preview-rollover-credits`,
      params: {
        packageCode,
        voucherCode,
      },
    });
    return response;
  } catch (error) {
    return { status: 0, errorCode: ERROR_CODE.BAD_REQUEST };
  }
};

const getReferredOrders = async ({ offset, limit, sort }) => {
  try {
    const params = omitIsNil({
      offset,
      limit,
      sort,
    });

    const response = await api({
      method: 'GET',
      url: '/referred-orders',
      params,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

export {
  remainingValueOfTheCurrentPackage,
  createOrder,
  createTrialDubbingOrder,
  getOrderState,
  getOrderById,
  getOrders,
  cancelOrder,
  confirmByCustomer,
  countPaidOrders,
  getLastExpiredOrder,
  updateMoeStatus,
  getUserPaidOrders,
  getUsingOrders,
  getPreviewRolloverCredits,
  getReferredOrders,
};
